const parseError = {
  methods: {
    parseErrorMessage(e) {
      const data = e && e.response && e.response.data
      if (data && data.detail && Array.isArray(data.detail)) {
        return data.detail.map(err => {
          const field = err.loc ? err.loc.join('.') : ''
          return field ? `${field}: ${err.msg}` : err.msg
        }).join('\n')
      }
      const errorMessage = (data && data.error && data.error.message) || (data && data.message)
      return errorMessage || `Something went wrong: ${e}`
    }
  }
}

export default parseError
